import React, {useEffect, useState} from 'react';

import {faCaretDown} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Icon from 'components/Icon/Icon';
import {BreweryTypeFilter} from 'components/Table/Tables/Breweries/BreweryTypeFilter';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setBreweryFiltersAC} from 'store/breweries/breweriesSlice';
import {setShowFilterAC} from 'store/filter/filterSlice';
import {handleQueryDirection} from 'utils/helpers/handleQueryDirection';

export const BreweriesHeader = () => {
  const dispatch = useSetGlobalState();

  const {show} = useGlobalState((state) => state.filter);
  const {filters} = useGlobalState((state) => state.breweries);

  const [toggleDropdown, setToggleDropdown] = useState(false);

  const handleSort = (column: 'country' | 'name') => {
    const direction = handleQueryDirection(column, filters);
    dispatch(setBreweryFiltersAC({...filters, column, direction}));
  };

  useEffect(() => {
    dispatch(setShowFilterAC(toggleDropdown));
    // eslint-disable-next-line
  }, [toggleDropdown]);

  return (
    <div className="breweries-table__header">
      <div className="breweries-table__name">
        Brewery Name
        <button className="breweries-table__sort" onClick={() => handleSort('name')}>
          <Icon icon="sort-2" />
        </button>
      </div>
      <div className="breweries-table__filter">
        Type
        <span className="breweries-table__filter-wrapper">
          <button className="breweries-table__sort" onClick={() => setToggleDropdown(!toggleDropdown)}>
            <FontAwesomeIcon icon={faCaretDown} />
          </button>
          {show && <BreweryTypeFilter show={show} />}
        </span>
      </div>
      <div className="breweries-table__name">
        Country
        <button className="breweries-table__sort" onClick={() => handleSort('country')}>
          <Icon icon="sort-2" />
        </button>
      </div>
      <div className="breweries-table__empty" />
    </div>
  );
};
